import { DayMeta, Question } from './types';

export const DAYS_META: DayMeta[] = [
  { day: 1, title: 'Tư duy vốn', group: 'Ngày 1 — Tư duy vốn', totalQuestions: 34, count: 34 },
  { day: 2, title: 'Hệ thống & Lợi thế', group: 'Ngày 2 — Hệ thống & Lợi thế', totalQuestions: 33, count: 33 },
  { day: 3, title: 'Quản trị rủi ro', group: 'Ngày 3 — Quản trị rủi ro', totalQuestions: 33, count: 33 },
];

export const ALL_QUESTIONS: Question[] = [
  // --- NGÀY 1 (34 CÂU) ---
  {
    id: 1,
    day: 1,
    competency: 'Tư duy vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi nhìn thấy một cơ hội rất hấp dẫn, điều đầu tiên bạn nghĩ đến là gì?',
    options: [
      { key: 'A', text: 'Xem nhanh cơ hội có hợp lý không rồi quyết định.', score: 3 },
      { key: 'B', text: 'Xác định rõ rủi ro, giới hạn vốn và chỉ hành động nếu đúng kế hoạch.', score: 5 },
      { key: 'C', text: 'Làm sao vào ngay trước khi giá chạy.', score: 1 },
      { key: 'D', text: 'Kiểm tra mức rủi ro và điều kiện trước khi nghĩ tới lợi nhuận.', score: 4 },
      { key: 'E', text: 'Có thể kiếm được bao nhiêu từ lệnh này.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 2,
    day: 1,
    competency: 'Bảo vệ vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Nếu phải chọn giữa bảo toàn vốn và cố đạt mục tiêu lợi nhuận trong ngày, bạn nghiêng về đâu?',
    options: [
      { key: 'A', text: 'Bảo toàn vốn luôn là điều kiện trước khi theo đuổi lợi nhuận.', score: 5 },
      { key: 'B', text: 'Cố đạt mục tiêu nhưng giảm nhẹ rủi ro.', score: 2 },
      { key: 'C', text: 'Ưu tiên bảo toàn vốn nếu cơ hội không đủ tốt.', score: 4 },
      { key: 'D', text: 'Ưu tiên mục tiêu lợi nhuận bằng mọi giá.', score: 1 },
      { key: 'E', text: 'Tùy trạng thái thị trường lúc đó.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 3,
    day: 1,
    competency: 'Trách nhiệm',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Một lệnh thua đúng kế hoạch khiến bạn phản ứng thế nào?',
    options: [
      { key: 'A', text: 'Tìm ngay nguyên nhân bên ngoài để giải thích.', score: 2 },
      { key: 'B', text: 'Rà soát quyết định và chấp nhận xác suất.', score: 4 },
      { key: 'C', text: 'Nhận hoàn toàn trách nhiệm với quyết định, tách kết quả khỏi chất lượng quy trình.', score: 5 },
      { key: 'D', text: 'Khó chịu nhưng vẫn chấp nhận một phần trách nhiệm.', score: 3 },
      { key: 'E', text: 'Cho rằng thị trường cố tình quét mình.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 4,
    day: 1,
    competency: 'Phân bổ vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn xem mỗi lệnh giao dịch là gì?',
    options: [
      { key: 'A', text: 'Một quyết định phân bổ một phần vốn có giới hạn.', score: 4 },
      { key: 'B', text: 'Một cơ hội kiếm tiền độc lập.', score: 1 },
      { key: 'C', text: 'Một quyết định có thể sinh lời hoặc thua lỗ.', score: 3 },
      { key: 'D', text: 'Một quyết định phân bổ vốn trong danh mục rủi ro tổng thể.', score: 5 },
      { key: 'E', text: 'Một lần dự đoán đúng/sai thị trường.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 5,
    day: 1,
    competency: 'Tư duy dài hạn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Một lệnh thắng lớn ảnh hưởng thế nào đến cách bạn tự đánh giá?',
    options: [
      { key: 'A', text: 'Chứng minh tôi đang rất giỏi.', score: 1 },
      { key: 'B', text: 'Là tín hiệu tích cực nhưng chưa đủ kết luận.', score: 3 },
      { key: 'C', text: 'Cho phép tôi tự tin hơn và tăng tốc.', score: 2 },
      { key: 'D', text: 'Không dùng một lệnh để đánh giá năng lực; chỉ nhìn tính lặp lại của quy trình.', score: 5 },
      { key: 'E', text: 'Ghi nhận nhưng tiếp tục nhìn chuỗi quyết định dài hơn.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 6,
    day: 1,
    competency: 'Kỷ luật quyết định',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi chưa chắc chắn 100%, bạn thường làm gì?',
    options: [
      { key: 'A', text: 'Chỉ hành động nếu điều kiện hệ thống đủ dù vẫn có bất định.', score: 4 },
      { key: 'B', text: 'Tìm thêm người xác nhận cho tới khi yên tâm.', score: 2 },
      { key: 'C', text: 'Vào lệnh để khỏi bỏ lỡ.', score: 1 },
      { key: 'D', text: 'Vào nhỏ để thử.', score: 3 },
      { key: 'E', text: 'Chấp nhận bất định là bình thường và chỉ quyết định theo tiêu chuẩn đã định.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 7,
    day: 1,
    competency: 'Không gỡ',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Sau một sai lầm khiến tài khoản giảm, ưu tiên tiếp theo là gì?',
    options: [
      { key: 'A', text: 'Tìm lệnh chắc nhất để lấy lại phần đã mất.', score: 2 },
      { key: 'B', text: 'Bảo vệ phần vốn còn lại, phục hồi trạng thái và quay về quy trình.', score: 5 },
      { key: 'C', text: 'Giảm nhẹ rủi ro nhưng vẫn cố phục hồi ngay.', score: 3 },
      { key: 'D', text: 'Gỡ lại càng nhanh càng tốt.', score: 1 },
      { key: 'E', text: 'Dừng, rà soát và chỉ tiếp tục khi kế hoạch cho phép.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 8,
    day: 1,
    competency: 'Trách nhiệm',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi thị trường đi ngược phân tích, bạn thường giải thích thế nào?',
    options: [
      { key: 'A', text: 'Xem đây là kết quả có thể xảy ra; đánh giá chính quyết định và rủi ro đã kiểm soát.', score: 5 },
      { key: 'B', text: 'Có thể phân tích sai hoặc thị trường đổi.', score: 3 },
      { key: 'C', text: 'Do tin tức hoặc tay to làm sai thị trường.', score: 1 },
      { key: 'D', text: 'Do thị trường bất thường nên không tính.', score: 2 },
      { key: 'E', text: 'Rà soát dữ liệu và quyết định của mình trước.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 9,
    day: 1,
    competency: 'Tư duy vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi không có cơ hội đạt chuẩn, bạn nhìn việc không giao dịch ra sao?',
    options: [
      { key: 'A', text: 'Khó chịu nhưng chấp nhận tạm thời.', score: 3 },
      { key: 'B', text: 'Là một ngày lãng phí.', score: 1 },
      { key: 'C', text: 'Là một quyết định quản lý vốn chủ động khi lợi thế chưa xuất hiện.', score: 5 },
      { key: 'D', text: 'Là dấu hiệu tôi chưa làm việc đủ.', score: 2 },
      { key: 'E', text: 'Là một lựa chọn hợp lệ để bảo vệ vốn.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 10,
    day: 1,
    competency: 'Kỷ luật',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Nếu một Mentor đưa ra quan điểm khác bạn, bạn làm gì?',
    options: [
      { key: 'A', text: 'Đổi ngay vì Mentor kinh nghiệm hơn.', score: 1 },
      { key: 'B', text: 'Hỏi dữ liệu cụ thể rồi tự đối chiếu hệ thống.', score: 4 },
      { key: 'C', text: 'Làm theo nhưng giảm rủi ro.', score: 2 },
      { key: 'D', text: 'Giữ quan điểm nhưng hơi dao động.', score: 3 },
      { key: 'E', text: 'Tiếp nhận dữ liệu mới nhưng giữ quyền quyết định và trách nhiệm cuối cùng.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 11,
    day: 1,
    competency: 'Tự nhận thức',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi cảm thấy rất hưng phấn trước thị trường, bạn xem trạng thái đó thế nào?',
    options: [
      { key: 'A', text: 'Không ảnh hưởng đáng kể.', score: 3 },
      { key: 'B', text: 'Là một biến số rủi ro có thể làm lệch quyết định và cần được quản lý.', score: 5 },
      { key: 'C', text: 'Là lúc nên tận dụng để giao dịch mạnh hơn.', score: 1 },
      { key: 'D', text: 'Là trạng thái cần được nhận diện trước quyết định.', score: 4 },
      { key: 'E', text: 'Là dấu hiệu tôi đang có phong độ tốt.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 12,
    day: 1,
    competency: 'Tư duy xác suất',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn hiểu một quyết định tốt như thế nào?',
    options: [
      { key: 'A', text: 'Quyết định tuân thủ hệ thống, rủi ro và dữ liệu dù kết quả sau đó có thể xấu.', score: 5 },
      { key: 'B', text: 'Quyết định có xác suất thắng cao nhất.', score: 2 },
      { key: 'C', text: 'Quyết định dựa trên thông tin và nguyên tắc đúng tại thời điểm đó.', score: 4 },
      { key: 'D', text: 'Quyết định tạo ra lợi nhuận.', score: 1 },
      { key: 'E', text: 'Quyết định hợp lý nếu cuối cùng không thua nhiều.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 13,
    day: 1,
    competency: 'Tách P&L',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Nếu một lệnh đúng quy trình nhưng thua, bạn đánh giá ra sao?',
    options: [
      { key: 'A', text: 'Hệ thống có vấn đề nên cần đổi ngay.', score: 2 },
      { key: 'B', text: 'Có thể vẫn là quyết định tốt.', score: 4 },
      { key: 'C', text: 'Vẫn là quyết định tốt nếu đúng điều kiện, đúng risk và không vi phạm quy trình.', score: 5 },
      { key: 'D', text: 'Chưa biết, cần xem thêm vài lệnh.', score: 3 },
      { key: 'E', text: 'Đó là quyết định sai vì bị lỗ.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 14,
    day: 1,
    competency: 'Trách nhiệm',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Ai chịu trách nhiệm cuối cùng cho quyết định trên tài khoản của bạn?',
    options: [
      { key: 'A', text: 'Tôi, trong phạm vi quy trình đã chọn.', score: 4 },
      { key: 'B', text: 'Thị trường.', score: 1 },
      { key: 'C', text: 'Hệ thống giao dịch.', score: 3 },
      { key: 'D', text: 'Tôi hoàn toàn chịu trách nhiệm cho việc tuân thủ hệ thống, risk và hành động của mình.', score: 5 },
      { key: 'E', text: 'Mentor hoặc người đưa tín hiệu.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 15,
    day: 1,
    competency: 'Tư duy vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi được giao số vốn lớn hơn, phản ứng phù hợp nhất là gì?',
    options: [
      { key: 'A', text: 'Tăng số lệnh để tận dụng vốn.', score: 1 },
      { key: 'B', text: 'Giữ cách cũ nhưng linh hoạt hơn.', score: 3 },
      { key: 'C', text: 'Tăng risk vì có biên an toàn lớn hơn.', score: 2 },
      { key: 'D', text: 'Quản lý theo cùng nguyên tắc, mandate và risk plan; quy mô không thay đổi kỷ luật.', score: 5 },
      { key: 'E', text: 'Giữ nguyên logic quản trị, chỉ thay đổi theo mandate nếu có.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 16,
    day: 1,
    competency: 'Tư duy dài hạn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn nhìn mục tiêu lợi nhuận ngày như thế nào?',
    options: [
      { key: 'A', text: 'Không được phép ép tôi phá tiêu chuẩn.', score: 4 },
      { key: 'B', text: 'Là động lực để giao dịch nhiều hơn.', score: 2 },
      { key: 'C', text: 'Phải hoàn thành bằng mọi giá.', score: 1 },
      { key: 'D', text: 'Là con số tham khảo.', score: 3 },
      { key: 'E', text: 'Chỉ là mục tiêu thứ cấp; chất lượng quyết định và bảo toàn vốn mới là ưu tiên.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 17,
    day: 1,
    competency: 'Kỷ luật',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi bỏ lỡ một cơ hội đã chạy rất xa, bạn nghĩ gì?',
    options: [
      { key: 'A', text: 'Lần sau cần vào sớm hơn dù chưa đủ điều kiện.', score: 2 },
      { key: 'B', text: 'Bỏ lỡ không làm mất vốn; tuyệt đối không biến tiếc nuối thành hành động dưới chuẩn.', score: 5 },
      { key: 'C', text: 'Tiếc nhưng chờ xem có điểm khác không.', score: 3 },
      { key: 'D', text: 'Phải tìm điểm vào để lấy phần còn lại.', score: 1 },
      { key: 'E', text: 'Chấp nhận bỏ lỡ và chờ setup mới.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 18,
    day: 1,
    competency: 'Tự chủ',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn muốn được Mentor hỗ trợ ở mức nào?',
    options: [
      { key: 'A', text: 'Mentor giúp tôi tự vận hành; quyết định cuối cùng vẫn do tôi chịu trách nhiệm.', score: 5 },
      { key: 'B', text: 'Mentor góp ý khi tôi không chắc.', score: 3 },
      { key: 'C', text: 'Mentor quyết định giúp tôi.', score: 1 },
      { key: 'D', text: 'Mentor xác nhận mọi lệnh trước khi vào.', score: 2 },
      { key: 'E', text: 'Mentor phản biện và giúp tôi nhìn dữ liệu.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 19,
    day: 1,
    competency: 'Quy trình',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi kết quả tốt nhưng quy trình kém, điều gì quan trọng hơn?',
    options: [
      { key: 'A', text: 'Nên ghi nhận cả hai.', score: 3 },
      { key: 'B', text: 'Kết quả tốt là đủ.', score: 1 },
      { key: 'C', text: 'Phải tách lợi nhuận khỏi chất lượng quyết định và sửa hành vi sai dù đang thắng.', score: 5 },
      { key: 'D', text: 'Nếu lời thì không cần soi quá kỹ.', score: 2 },
      { key: 'E', text: 'Phải ghi nhận vi phạm quy trình.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 20,
    day: 1,
    competency: 'Bảo vệ vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn xem Stop Loss như thế nào?',
    options: [
      { key: 'A', text: 'Một thứ có thể nới nếu thị trường sắp quay lại.', score: 1 },
      { key: 'B', text: 'Một giới hạn rủi ro phải tôn trọng.', score: 4 },
      { key: 'C', text: 'Một mức tham khảo.', score: 2 },
      { key: 'D', text: 'Một công cụ kỹ thuật.', score: 3 },
      { key: 'E', text: 'Một cam kết bảo vệ vốn đã được xác định trước, không được thương lượng theo cảm xúc.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 21,
    day: 1,
    competency: 'Tư duy vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Nếu một ngày không có lệnh nhưng bạn tuân thủ đúng hệ thống, bạn đánh giá ngày đó thế nào?',
    options: [
      { key: 'A', text: 'Bình thường.', score: 3 },
      { key: 'B', text: 'Là ngày quản lý vốn tốt nếu không có cơ hội đủ chuẩn.', score: 5 },
      { key: 'C', text: 'Thất bại vì không kiếm tiền.', score: 1 },
      { key: 'D', text: 'Là ngày có kỷ luật.', score: 4 },
      { key: 'E', text: 'Thiếu hiệu suất.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 22,
    day: 1,
    competency: 'Trách nhiệm',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi một quyết định sai, bước đầu tiên của bạn là gì?',
    options: [
      { key: 'A', text: 'Nhận trách nhiệm, khoanh vùng sai lệch và ngăn nó lặp lại trước lệnh tiếp theo.', score: 5 },
      { key: 'B', text: 'Xem có thể gỡ lại ngay không.', score: 2 },
      { key: 'C', text: 'Xác định điểm mình đã lệch quy trình.', score: 4 },
      { key: 'D', text: 'Tìm ai hoặc điều gì gây ra sai.', score: 1 },
      { key: 'E', text: 'Xem kết quả ảnh hưởng bao nhiêu.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 23,
    day: 1,
    competency: 'Tự nhận thức',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi áp lực tăng, điều gì nên được kiểm tra trước khi bấm nút?',
    options: [
      { key: 'A', text: 'Người khác đang làm gì.', score: 2 },
      { key: 'B', text: 'Trạng thái cảm xúc và mức tập trung.', score: 4 },
      { key: 'C', text: 'Trạng thái bản thân, hệ thống, risk và quyền được giao dịch đều phải đạt chuẩn.', score: 5 },
      { key: 'D', text: 'P&L hiện tại.', score: 3 },
      { key: 'E', text: 'Khả năng giá chạy nhanh.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 24,
    day: 1,
    competency: 'Tư duy xác suất',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn xem thua lỗ hợp lệ như thế nào?',
    options: [
      { key: 'A', text: 'Là chi phí của một quy trình xác suất.', score: 4 },
      { key: 'B', text: 'Là dấu hiệu phải đổi hệ thống.', score: 1 },
      { key: 'C', text: 'Là điều khó tránh.', score: 3 },
      { key: 'D', text: 'Là kết quả bình thường nếu quyết định đúng; điều cần kiểm soát là kích thước và chuỗi rủi ro.', score: 5 },
      { key: 'E', text: 'Là thất bại cá nhân.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 25,
    day: 1,
    competency: 'Bảo vệ vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi vốn giảm, ưu tiên số một là gì?',
    options: [
      { key: 'A', text: 'Tìm cơ hội lớn để hồi phục.', score: 1 },
      { key: 'B', text: 'Giảm cảm giác khó chịu.', score: 3 },
      { key: 'C', text: 'Tăng tần suất giao dịch.', score: 2 },
      { key: 'D', text: 'Bảo vệ khả năng tiếp tục vận hành bằng cách quay về giới hạn rủi ro.', score: 5 },
      { key: 'E', text: 'Giữ kỷ luật và hạn chế tổn thất tiếp.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 26,
    day: 1,
    competency: 'Tư duy vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Bạn phân biệt Trader và Nhà Quản lý Vốn rõ nhất ở đâu?',
    options: [
      { key: 'A', text: 'Nhà Quản lý Vốn quản lý rủi ro trước cơ hội.', score: 4 },
      { key: 'B', text: 'Nhà Quản lý Vốn dự đoán chính xác hơn.', score: 2 },
      { key: 'C', text: 'Nhà Quản lý Vốn giao dịch nhiều hơn.', score: 1 },
      { key: 'D', text: 'Nhà Quản lý Vốn có tài khoản lớn hơn.', score: 3 },
      { key: 'E', text: 'Nhà Quản lý Vốn chịu trách nhiệm với vốn, quy trình và chuỗi quyết định chứ không chỉ tìm điểm vào.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 27,
    day: 1,
    competency: 'Tính nhất quán',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi hoàn cảnh thay đổi nhưng nguyên tắc cốt lõi không đổi, bạn làm gì?',
    options: [
      { key: 'A', text: 'Theo kết quả gần nhất.', score: 2 },
      { key: 'B', text: 'Giữ nguyên tắc nhất quán, chỉ thay đổi khi điều kiện/mandate/hệ thống quy định rõ.', score: 5 },
      { key: 'C', text: 'Tùy từng lần quyết định.', score: 3 },
      { key: 'D', text: 'Đổi nguyên tắc theo cảm giác.', score: 1 },
      { key: 'E', text: 'Giữ nguyên tắc và chỉ cập nhật khi dữ liệu đủ mạnh.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 28,
    day: 1,
    competency: 'Ra quyết định',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi phải quyết định nhanh, bạn dựa vào gì?',
    options: [
      { key: 'A', text: 'Tiêu chuẩn, risk và checklist đã chuẩn hóa để tránh quyết định theo thôi thúc.', score: 5 },
      { key: 'B', text: 'Kinh nghiệm gần nhất.', score: 3 },
      { key: 'C', text: 'Trực giác tức thời.', score: 1 },
      { key: 'D', text: 'Cảm giác tự tin.', score: 2 },
      { key: 'E', text: 'Checklist ngắn đã định trước.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 29,
    day: 1,
    competency: 'Tư duy dài hạn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Một chuỗi 3 lệnh thắng có ý nghĩa gì?',
    options: [
      { key: 'A', text: 'Có thể tôi đang vào form.', score: 3 },
      { key: 'B', text: 'Tôi nên tăng risk.', score: 1 },
      { key: 'C', text: 'Không tự động thay đổi xác suất lệnh tiếp theo; vẫn giữ risk plan và tiêu chuẩn.', score: 5 },
      { key: 'D', text: 'Hệ thống chắc chắn đang rất tốt.', score: 2 },
      { key: 'E', text: 'Là dữ liệu tích cực nhưng chưa đủ thay đổi quy trình.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 30,
    day: 1,
    competency: 'Kỷ luật',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Nếu hôm nay bạn không đạt mục tiêu lợi nhuận nhưng tuân thủ hoàn hảo, bạn chọn đánh giá nào?',
    options: [
      { key: 'A', text: 'Ngày thất bại.', score: 1 },
      { key: 'B', text: 'Ngày tốt về quy trình.', score: 4 },
      { key: 'C', text: 'Ngày không hiệu quả.', score: 2 },
      { key: 'D', text: 'Ngày trung tính.', score: 3 },
      { key: 'E', text: 'Ngày thành công về kỷ luật vì mục tiêu quá trình được giữ nguyên.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 31,
    day: 1,
    competency: 'Trách nhiệm',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Nếu bạn vào lệnh do lời khuyên người khác và lệnh thua, bạn nghĩ sao?',
    options: [
      { key: 'A', text: 'Cả hai cùng chịu.', score: 3 },
      { key: 'B', text: 'Tôi chịu trách nhiệm hoàn toàn vì đã giao quyền quyết định của mình cho người khác.', score: 5 },
      { key: 'C', text: 'Người đó chịu trách nhiệm.', score: 1 },
      { key: 'D', text: 'Tôi chịu trách nhiệm vì đã chọn làm theo.', score: 4 },
      { key: 'E', text: 'Tại họ khiến tôi sai.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 32,
    day: 1,
    competency: 'Tự chủ',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Khi không chắc nên giao dịch hay đứng ngoài, tiêu chí cuối cùng là gì?',
    options: [
      { key: 'A', text: 'Chỉ giao dịch khi đủ điều kiện hệ thống, risk, trạng thái và mandate; nếu chưa rõ thì đứng ngoài.', score: 5 },
      { key: 'B', text: 'P&L đang cần gì.', score: 2 },
      { key: 'C', text: 'Hệ thống và risk plan có cho phép không.', score: 4 },
      { key: 'D', text: 'Cảm giác bỏ lỡ.', score: 1 },
      { key: 'E', text: 'Người khác đang làm gì.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 33,
    day: 1,
    competency: 'Bảo vệ vốn',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Một Nhà Quản lý Vốn giỏi cần chứng minh điều gì trước tiên?',
    options: [
      { key: 'A', text: 'Khả năng thắng liên tục.', score: 2 },
      { key: 'B', text: 'Khả năng giữ vốn và tuân thủ quy trình.', score: 4 },
      { key: 'C', text: 'Khả năng bảo toàn quyền tiếp tục giao dịch thông qua kỷ luật, risk và tính nhất quán.', score: 5 },
      { key: 'D', text: 'Khả năng đọc đúng thị trường.', score: 3 },
      { key: 'E', text: 'Khả năng kiếm nhanh.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 34,
    day: 1,
    competency: 'Tổng hợp',
    group: 'Ngày 1 — Tư duy vốn',
    text: 'Sau 3 ngày đầu, dấu hiệu rõ nhất cho thấy bạn đã chuyển tư duy là gì?',
    options: [
      { key: 'A', text: 'Tôi suy nghĩ về rủi ro trước khi vào lệnh.', score: 4 },
      { key: 'B', text: 'Tôi tự tin vào dự đoán hơn.', score: 1 },
      { key: 'C', text: 'Tôi biết thêm nhiều setup.', score: 3 },
      { key: 'D', text: 'Tôi chủ động quản lý vốn, hệ thống, rủi ro và trạng thái trước khi nghĩ tới lợi nhuận.', score: 5 },
      { key: 'E', text: 'Tôi muốn giao dịch nhiều hơn.', score: 2 }
    ],
    maxScore: 5
  },

  // --- NGÀY 2 (33 CÂU) ---
  {
    id: 35,
    day: 2,
    competency: 'Setup',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn mô tả Setup của mình rõ đến mức nào?',
    options: [
      { key: 'A', text: 'Tôi vào khi nhìn thấy cảm giác quen thuộc.', score: 1 },
      { key: 'B', text: 'Tôi có mô tả chung.', score: 3 },
      { key: 'C', text: 'Tôi có vài dấu hiệu nhưng không cố định.', score: 2 },
      { key: 'D', text: 'Tôi có tiêu chí bắt buộc, bối cảnh, điểm vào, vô hiệu hóa và điều kiện không giao dịch.', score: 5 },
      { key: 'E', text: 'Tôi có điều kiện chính và phụ khá rõ.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 36,
    day: 2,
    competency: 'Lợi thế',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn xác định lợi thế của mình dựa trên gì?',
    options: [
      { key: 'A', text: 'Mẫu hình lặp lại và dữ liệu quan sát.', score: 4 },
      { key: 'B', text: 'Một vài lệnh thắng gần đây.', score: 2 },
      { key: 'C', text: 'Cảm giác thị trường thường đi theo mình.', score: 1 },
      { key: 'D', text: 'Kinh nghiệm cá nhân chưa đo lường.', score: 3 },
      { key: 'E', text: 'Điều kiện có thể mô tả, kiểm chứng, lặp lại và tạo xác suất thuận lợi hơn mức ngẫu nhiên.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 37,
    day: 2,
    competency: 'Điều kiện vào',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Khi một Setup thiếu một điều kiện bắt buộc, bạn làm gì?',
    options: [
      { key: 'A', text: 'Vào nhỏ để khỏi bỏ lỡ.', score: 2 },
      { key: 'B', text: 'Không giao dịch cho tới khi đủ điều kiện hoặc bỏ cơ hội.', score: 5 },
      { key: 'C', text: 'Cân nhắc theo tốc độ giá.', score: 3 },
      { key: 'D', text: 'Vào bình thường vì hình vẫn đẹp.', score: 1 },
      { key: 'E', text: 'Chờ thêm xác nhận.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 38,
    day: 2,
    competency: 'No-trade',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Điều kiện KHÔNG giao dịch của bạn rõ đến đâu?',
    options: [
      { key: 'A', text: 'Có checklist bắt buộc và đứng ngoài ngay khi một điều kiện cấm xuất hiện.', score: 5 },
      { key: 'B', text: 'Có vài tình huống nhưng không cố định.', score: 3 },
      { key: 'C', text: 'Tôi không có danh sách.', score: 1 },
      { key: 'D', text: 'Chủ yếu dựa vào cảm giác.', score: 2 },
      { key: 'E', text: 'Có danh sách khá rõ.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 39,
    day: 2,
    competency: 'Thị trường phù hợp',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn chọn thị trường để giao dịch như thế nào?',
    options: [
      { key: 'A', text: 'Theo thói quen.', score: 3 },
      { key: 'B', text: 'Thị trường nào đang chạy mạnh thì vào.', score: 1 },
      { key: 'C', text: 'Chỉ chọn thị trường/bối cảnh nơi edge của hệ thống thực sự được xác nhận.', score: 5 },
      { key: 'D', text: 'Thị trường đang được nhiều người chú ý.', score: 2 },
      { key: 'E', text: 'Theo mức độ phù hợp với Setup.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 40,
    day: 2,
    competency: 'Khung thời gian',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn dùng khung thời gian như thế nào?',
    options: [
      { key: 'A', text: 'Đổi khung để tìm điểm vào nếu khung chính không có.', score: 1 },
      { key: 'B', text: 'Có khung chính và khung xác nhận.', score: 4 },
      { key: 'C', text: 'Xem nhiều khung rồi chọn khung dễ vào nhất.', score: 2 },
      { key: 'D', text: 'Linh hoạt theo cảm giác.', score: 3 },
      { key: 'E', text: 'Có cấu trúc đa khung rõ ràng, không đổi khung để hợp thức hóa quyết định.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 41,
    day: 2,
    competency: 'Điểm vào',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Một điểm vào hợp lệ với bạn là gì?',
    options: [
      { key: 'A', text: 'Có vài tín hiệu phù hợp.', score: 3 },
      { key: 'B', text: 'Đúng bối cảnh, đúng Setup, đủ xác nhận và còn tỷ lệ rủi ro/lợi nhuận theo kế hoạch.', score: 5 },
      { key: 'C', text: 'Giá đang chạy đúng hướng.', score: 1 },
      { key: 'D', text: 'Đúng vùng và đủ điều kiện chính.', score: 4 },
      { key: 'E', text: 'Điểm trông đẹp trên biểu đồ.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 42,
    day: 2,
    competency: 'Điểm thoát',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn xác định điểm thoát khi nào?',
    options: [
      { key: 'A', text: 'SL, TP và nguyên tắc quản lý vị thế phải được xác định trước khi vào.', score: 5 },
      { key: 'B', text: 'Khi giá chạy mới điều chỉnh.', score: 2 },
      { key: 'C', text: 'Xác định SL/TP trước phần lớn giao dịch.', score: 4 },
      { key: 'D', text: 'Sau khi vào rồi mới tính.', score: 1 },
      { key: 'E', text: 'Có ý tưởng trước nhưng không cố định.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 43,
    day: 2,
    competency: 'Outcome bias',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Một lệnh sai Setup nhưng thắng lớn được bạn ghi nhận thế nào?',
    options: [
      { key: 'A', text: 'Là bằng chứng tôi đọc thị trường tốt.', score: 2 },
      { key: 'B', text: 'Là kết quả tốt nhưng quyết định kém.', score: 4 },
      { key: 'C', text: 'Là vi phạm quy trình; lợi nhuận không được phép che khuất chất lượng quyết định.', score: 5 },
      { key: 'D', text: 'Là lệnh thắng nhưng có chút lỗi.', score: 3 },
      { key: 'E', text: 'Là lệnh tuyệt vời.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 44,
    day: 2,
    competency: 'Can thiệp vị thế',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Giá rung lắc nhưng chưa có điều kiện thoát. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Giữ kế hoạch nếu chưa có dữ liệu mới.', score: 4 },
      { key: 'B', text: 'Thoát ngay cho an toàn.', score: 1 },
      { key: 'C', text: 'Giảm vị thế để đỡ áp lực.', score: 3 },
      { key: 'D', text: 'Chỉ điều chỉnh khi quy tắc quản lý vị thế cho phép; không can thiệp vì P&L.', score: 5 },
      { key: 'E', text: 'Dời SL theo cảm giác.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 45,
    day: 2,
    competency: 'FOMO',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn nhận diện FOMO rõ nhất ở dấu hiệu nào?',
    options: [
      { key: 'A', text: 'Giá đang tăng nhanh.', score: 1 },
      { key: 'B', text: 'Tôi thấy hơi tiếc.', score: 3 },
      { key: 'C', text: 'Nhiều người cùng vào.', score: 2 },
      { key: 'D', text: 'Tôi thấy cấp bách, hạ tiêu chuẩn hoặc tìm lý do mới chỉ vì sợ bỏ lỡ.', score: 5 },
      { key: 'E', text: 'Tôi muốn vào dù điều kiện chưa đủ.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 46,
    day: 2,
    competency: 'Chase',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Điểm vào đã mất, giá đi xa. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Chờ điểm vào mới hợp lệ.', score: 4 },
      { key: 'B', text: 'Vào nhỏ hơn.', score: 2 },
      { key: 'C', text: 'Đuổi theo ngay.', score: 1 },
      { key: 'D', text: 'Tìm khung nhỏ để có lý do vào.', score: 3 },
      { key: 'E', text: 'Bỏ cơ hội cũ; chỉ xem xét khi hình thành Setup mới hoàn chỉnh.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 47,
    day: 2,
    competency: 'Hạ tiêu chuẩn',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Khi rất muốn có lệnh, bạn xử lý tiêu chuẩn Setup ra sao?',
    options: [
      { key: 'A', text: 'Cho phép ngoại lệ.', score: 2 },
      { key: 'B', text: 'Không thay đổi tiêu chuẩn chỉ vì nhu cầu hành động; không đủ thì không giao dịch.', score: 5 },
      { key: 'C', text: 'Tự thuyết phục rằng gần đủ là đủ.', score: 3 },
      { key: 'D', text: 'Bỏ bớt điều kiện.', score: 1 },
      { key: 'E', text: 'Giữ nguyên checklist.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 48,
    day: 2,
    competency: 'Tín hiệu vs cơ hội',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn phân biệt tín hiệu với cơ hội thế nào?',
    options: [
      { key: 'A', text: 'Tín hiệu chỉ là dữ liệu; cơ hội phải hội đủ Setup, bối cảnh, risk và điều kiện thực thi.', score: 5 },
      { key: 'B', text: 'Tín hiệu là một phần của cơ hội.', score: 3 },
      { key: 'C', text: 'Có tín hiệu là có cơ hội.', score: 1 },
      { key: 'D', text: 'Tín hiệu mạnh là đủ.', score: 2 },
      { key: 'E', text: 'Cơ hội cần thêm bối cảnh và risk phù hợp.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 49,
    day: 2,
    competency: 'Lợi thế lặp lại',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Điều gì chứng minh edge của bạn có giá trị?',
    options: [
      { key: 'A', text: 'Cảm giác tự tin.', score: 3 },
      { key: 'B', text: 'Một lệnh thắng lớn.', score: 1 },
      { key: 'C', text: 'Dữ liệu đủ mẫu cho thấy điều kiện cụ thể tạo xác suất thuận lợi và có thể tái thực thi.', score: 5 },
      { key: 'D', text: 'Một tuần tốt.', score: 2 },
      { key: 'E', text: 'Sự lặp lại có kết quả trên nhiều mẫu.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 50,
    day: 2,
    competency: 'Nhật ký',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn dùng nhật ký giao dịch để làm gì?',
    options: [
      { key: 'A', text: 'Ghi lời/lỗ.', score: 1 },
      { key: 'B', text: 'Đánh giá Setup và tuân thủ.', score: 4 },
      { key: 'C', text: 'Ghi điểm vào và thoát.', score: 2 },
      { key: 'D', text: 'Ghi thêm cảm xúc.', score: 3 },
      { key: 'E', text: 'Tách kết quả khỏi quy trình, đo edge, hành vi, risk và tính nhất quán theo thời gian.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 51,
    day: 2,
    competency: 'Thay đổi hệ thống',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Sau 2 lệnh thua, bạn muốn thay đổi hệ thống. Cách phù hợp nhất?',
    options: [
      { key: 'A', text: 'Giảm tiêu chuẩn để dễ thắng.', score: 3 },
      { key: 'B', text: 'Không thay đổi hệ thống từ một chuỗi nhỏ; chỉ sửa khi dữ liệu đủ và quy trình review cho phép.', score: 5 },
      { key: 'C', text: 'Đổi ngay Setup.', score: 1 },
      { key: 'D', text: 'Chờ đủ dữ liệu rồi đánh giá.', score: 4 },
      { key: 'E', text: 'Thêm indicator.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 52,
    day: 2,
    competency: 'Xác nhận',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Khi hai chỉ báo mâu thuẫn nhau, bạn làm gì?',
    options: [
      { key: 'A', text: 'Nếu hệ thống không quy định cách xử lý mâu thuẫn, đứng ngoài thay vì tự chế luật tại chỗ.', score: 5 },
      { key: 'B', text: 'Bỏ qua cái yếu hơn.', score: 2 },
      { key: 'C', text: 'Đối chiếu quy tắc ưu tiên của hệ thống.', score: 4 },
      { key: 'D', text: 'Chọn cái ủng hộ ý muốn vào.', score: 1 },
      { key: 'E', text: 'Vào nhỏ để thử.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 53,
    day: 2,
    competency: 'Bối cảnh',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Một Setup đúng hình nhưng sai bối cảnh thị trường, bạn đánh giá thế nào?',
    options: [
      { key: 'A', text: 'Giảm risk rồi vào.', score: 2 },
      { key: 'B', text: 'Không ưu tiên.', score: 4 },
      { key: 'C', text: 'Không phải cơ hội hợp lệ nếu bối cảnh là điều kiện của edge.', score: 5 },
      { key: 'D', text: 'Có thể vào nếu RR đẹp.', score: 3 },
      { key: 'E', text: 'Vẫn giao dịch vì hình đúng.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 54,
    day: 2,
    competency: 'RR',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Một Setup tốt nhưng tỷ lệ rủi ro/lợi nhuận không đạt chuẩn, bạn làm gì?',
    options: [
      { key: 'A', text: 'Chờ điểm tốt hơn.', score: 4 },
      { key: 'B', text: 'Vào vì xác suất cao.', score: 1 },
      { key: 'C', text: 'Giảm SL cho vừa chuẩn.', score: 3 },
      { key: 'D', text: 'Không giao dịch nếu RR tối thiểu là điều kiện bắt buộc của hệ thống.', score: 5 },
      { key: 'E', text: 'Tăng TP để RR đẹp hơn.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 55,
    day: 2,
    competency: 'Điểm vô hiệu',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn hiểu điểm vô hiệu của Setup như thế nào?',
    options: [
      { key: 'A', text: 'Mức tôi không muốn lỗ thêm.', score: 1 },
      { key: 'B', text: 'Một vùng tham khảo.', score: 3 },
      { key: 'C', text: 'Điểm giá khiến tôi khó chịu.', score: 2 },
      { key: 'D', text: 'Điểm được xác định trước dựa trên cấu trúc/logic Setup và dùng để thiết kế SL hợp lý.', score: 5 },
      { key: 'E', text: 'Điểm chứng minh giả thuyết giao dịch không còn đúng.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 56,
    day: 2,
    competency: 'Kỷ luật hệ thống',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Nếu lệnh thắng dù bạn bỏ qua một điều kiện, bạn làm gì lần sau?',
    options: [
      { key: 'A', text: 'Ghi nhận vi phạm và quay lại chuẩn cũ.', score: 4 },
      { key: 'B', text: 'Cho điều kiện đó là không cần thiết.', score: 2 },
      { key: 'C', text: 'Lặp lại vì đã hiệu quả.', score: 1 },
      { key: 'D', text: 'Theo dõi thêm nhưng tiếp tục dùng.', score: 3 },
      { key: 'E', text: 'Không cho kết quả ngắn hạn sửa luật; muốn thay đổi điều kiện phải qua dữ liệu và review.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 57,
    day: 2,
    competency: 'Tự biện minh',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn nhận ra mình đang tự biện minh khi nào?',
    options: [
      { key: 'A', text: 'Khi thị trường đi nhanh.', score: 2 },
      { key: 'B', text: 'Khi lý do vào lệnh xuất hiện sau ham muốn hành động và không nằm trong checklist ban đầu.', score: 5 },
      { key: 'C', text: 'Khi tôi đổi ý nhiều lần.', score: 3 },
      { key: 'D', text: 'Khi lệnh đang thua.', score: 1 },
      { key: 'E', text: 'Khi bắt đầu thêm lý do sau khi đã muốn vào.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 58,
    day: 2,
    competency: 'Chính trực dữ liệu',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Một giao dịch lời nhưng sai quy trình nên được gắn nhãn thế nào?',
    options: [
      { key: 'A', text: 'Kết quả tài chính dương nhưng chất lượng quyết định phải bị ghi nhận là vi phạm.', score: 5 },
      { key: 'B', text: 'Win có lỗi.', score: 3 },
      { key: 'C', text: 'Win tốt.', score: 1 },
      { key: 'D', text: 'Win may mắn.', score: 2 },
      { key: 'E', text: 'Kết quả thắng, quy trình không đạt.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 59,
    day: 2,
    competency: 'Tính nhất quán',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Cùng một Setup xuất hiện vào hai ngày khác nhau, tiêu chuẩn có thay đổi theo P&L không?',
    options: [
      { key: 'A', text: 'Có thể điều chỉnh linh hoạt.', score: 3 },
      { key: 'B', text: 'Có, nếu đang thua thì cần nới.', score: 1 },
      { key: 'C', text: 'Tiêu chuẩn Setup độc lập với P&L; chỉ risk plan/mandate được phép quyết định thay đổi.', score: 5 },
      { key: 'D', text: 'Có, nếu đang thắng thì có thể mạnh tay hơn.', score: 2 },
      { key: 'E', text: 'Không nếu Risk Plan không quy định.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 60,
    day: 2,
    competency: 'Thực thi',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Khi mọi điều kiện đã đủ nhưng bạn sợ vào, bạn làm gì?',
    options: [
      { key: 'A', text: 'Bỏ lệnh.', score: 1 },
      { key: 'B', text: 'Thực thi theo kế hoạch đã định.', score: 4 },
      { key: 'C', text: 'Chờ thêm rất nhiều xác nhận.', score: 2 },
      { key: 'D', text: 'Vào nhỏ hơn tùy cảm giác.', score: 3 },
      { key: 'E', text: 'Nếu trạng thái cá nhân đạt chuẩn và hệ thống đủ điều kiện, thực thi dứt khoát đúng mức risk.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 61,
    day: 2,
    competency: 'Không giao dịch',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Một ngày không có Setup đạt chuẩn, bạn làm gì?',
    options: [
      { key: 'A', text: 'Chọn Setup tốt nhất trong số chưa đạt.', score: 3 },
      { key: 'B', text: 'Giữ vốn ở trạng thái chờ và ghi nhận đó là quyết định đúng hệ thống.', score: 5 },
      { key: 'C', text: 'Tìm hệ thống khác.', score: 1 },
      { key: 'D', text: 'Không giao dịch.', score: 4 },
      { key: 'E', text: 'Mở thêm thị trường cho tới khi có lệnh.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 62,
    day: 2,
    competency: 'Kiểm chứng edge',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn muốn cải thiện edge. Bước đầu tiên là gì?',
    options: [
      { key: 'A', text: 'Đo điều kiện nào thực sự tạo khác biệt về xác suất, RR và chất lượng thực thi trên dữ liệu đủ mẫu.', score: 5 },
      { key: 'B', text: 'Học thêm một hệ thống.', score: 2 },
      { key: 'C', text: 'Phân loại dữ liệu các Setup hiện tại.', score: 4 },
      { key: 'D', text: 'Thêm chỉ báo mới.', score: 1 },
      { key: 'E', text: 'Tăng số lệnh để có cảm giác.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 63,
    day: 2,
    competency: 'Exit rule',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Lệnh đang +2R nhưng chưa tới TP và không có tín hiệu thoát. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Chốt phần lớn để chắc lời.', score: 2 },
      { key: 'B', text: 'Theo kế hoạch quản lý vị thế.', score: 4 },
      { key: 'C', text: 'Không can thiệp ngoài quy tắc đã định; lợi nhuận đang có không phải lý do tự động để thay đổi kế hoạch.', score: 5 },
      { key: 'D', text: 'Dời SL thật sát.', score: 3 },
      { key: 'E', text: 'Chốt hết ngay.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 64,
    day: 2,
    competency: 'No-trade',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn đang mệt và mất tập trung nhưng Setup rất đẹp. Nếu trạng thái là điều kiện hệ thống, bạn làm gì?',
    options: [
      { key: 'A', text: 'Cân nhắc đứng ngoài.', score: 4 },
      { key: 'B', text: 'Vào bình thường.', score: 1 },
      { key: 'C', text: 'Nhờ người khác xác nhận rồi vào.', score: 3 },
      { key: 'D', text: 'Không giao dịch nếu trạng thái cá nhân vi phạm điều kiện no-trade đã cam kết.', score: 5 },
      { key: 'E', text: 'Vào nửa risk.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 65,
    day: 2,
    competency: 'Edge vs confidence',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Bạn cảm thấy cực kỳ tự tin nhưng Setup chỉ ở mức trung bình. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Tăng risk vì trực giác tốt.', score: 1 },
      { key: 'B', text: 'Vào nhỏ để kiểm tra.', score: 3 },
      { key: 'C', text: 'Vào vì tự tin là lợi thế.', score: 2 },
      { key: 'D', text: 'Nếu Setup không đạt chuẩn thì không giao dịch; confidence không thay thế edge.', score: 5 },
      { key: 'E', text: 'Giữ risk bình thường nếu vẫn đạt chuẩn.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 66,
    day: 2,
    competency: 'Chuẩn hóa',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Điều gì giúp hệ thống của bạn dễ lặp lại nhất?',
    options: [
      { key: 'A', text: 'Checklist và tiêu chí rõ.', score: 4 },
      { key: 'B', text: 'Nhiều kinh nghiệm cảm tính hơn.', score: 2 },
      { key: 'C', text: 'Nhiều indicator hơn.', score: 1 },
      { key: 'D', text: 'Nhiều thời gian nhìn chart hơn.', score: 3 },
      { key: 'E', text: 'Định nghĩa Setup, context, entry, exit, no-trade và review bằng tiêu chí có thể kiểm tra.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 67,
    day: 2,
    competency: 'Tổng hợp',
    group: 'Ngày 2 — Hệ thống & Lợi thế',
    text: 'Dấu hiệu mạnh nhất cho thấy bạn hiểu ‘My System — My Edge’ là gì?',
    options: [
      { key: 'A', text: 'Tôi vào lệnh nhanh hơn.', score: 2 },
      { key: 'B', text: 'Tôi mô tả được edge, điều kiện vào/thoát/no-trade và giữ chúng ổn định bất kể kết quả ngắn hạn.', score: 5 },
      { key: 'C', text: 'Tôi tự tin hơn.', score: 3 },
      { key: 'D', text: 'Tôi có nhiều setup để chọn.', score: 1 },
      { key: 'E', text: 'Tôi biết điều kiện nào cho phép và cấm giao dịch.', score: 4 }
    ],
    maxScore: 5
  },

  // --- NGÀY 3 (33 CÂU) ---
  {
    id: 68,
    day: 3,
    competency: 'Risk per trade',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Trước mỗi lệnh, bạn xác định mức rủi ro khi nào?',
    options: [
      { key: 'A', text: 'Trước khi vào, dựa trên Risk Plan, khoảng SL và giới hạn vốn còn lại.', score: 5 },
      { key: 'B', text: 'Ngay lúc đặt SL.', score: 3 },
      { key: 'C', text: 'Sau khi vào lệnh.', score: 1 },
      { key: 'D', text: 'Khi giá bắt đầu đi ngược.', score: 2 },
      { key: 'E', text: 'Trước khi bấm nút.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 69,
    day: 3,
    competency: 'Giới hạn ngày',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Nếu chạm mức lỗ tối đa trong ngày, bạn làm gì?',
    options: [
      { key: 'A', text: 'Nghỉ một lúc rồi vào lại.', score: 3 },
      { key: 'B', text: 'Tiếp tục nếu có Setup đẹp.', score: 1 },
      { key: 'C', text: 'Dừng bắt buộc, ghi nhận trạng thái và chỉ quay lại theo quy trình ngày kế tiếp hoặc điều kiện đã định.', score: 5 },
      { key: 'D', text: 'Giảm risk và giao dịch tiếp.', score: 2 },
      { key: 'E', text: 'Dừng giao dịch.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 70,
    day: 3,
    competency: 'Giới hạn tuần',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi gần chạm giới hạn lỗ tuần, bạn xử lý thế nào?',
    options: [
      { key: 'A', text: 'Tăng risk để hồi nhanh.', score: 1 },
      { key: 'B', text: 'Áp dụng quy tắc bảo vệ tuần.', score: 4 },
      { key: 'C', text: 'Giữ nguyên như chưa có gì.', score: 2 },
      { key: 'D', text: 'Giảm tùy cảm giác.', score: 3 },
      { key: 'E', text: 'Giảm/dừng đúng mức đã quy định và review trước khi được phép tiếp tục.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 71,
    day: 3,
    competency: 'Stop Loss',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Một lệnh không có Stop Loss rõ ràng nên được xử lý thế nào?',
    options: [
      { key: 'A', text: 'Dùng mức lỗ tiền tối đa để theo dõi.', score: 3 },
      { key: 'B', text: 'Không được phép vào; SL là điều kiện bắt buộc để lượng hóa rủi ro.', score: 5 },
      { key: 'C', text: 'Vào rồi quản lý tay.', score: 1 },
      { key: 'D', text: 'Chưa vào cho tới khi có SL hợp lý.', score: 4 },
      { key: 'E', text: 'Vào nhỏ hơn.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 72,
    day: 3,
    competency: 'Dời SL',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi giá gần chạm SL nhưng bạn vẫn tin phân tích đúng, bạn làm gì?',
    options: [
      { key: 'A', text: 'Không di chuyển SL để né thua; chỉ thay đổi nếu quy tắc quản lý vị thế cho phép từ trước.', score: 5 },
      { key: 'B', text: 'Bỏ SL và theo dõi.', score: 2 },
      { key: 'C', text: 'Giữ SL đã cam kết.', score: 4 },
      { key: 'D', text: 'Nới SL để tránh bị quét.', score: 1 },
      { key: 'E', text: 'Dời thêm một chút.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 73,
    day: 3,
    competency: 'Tăng risk',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Sau hai lệnh thua, bạn muốn tăng risk để gỡ. Bạn xử lý thế nào?',
    options: [
      { key: 'A', text: 'Tăng nhẹ vì cơ hội sau có thể tốt hơn.', score: 2 },
      { key: 'B', text: 'Giữ risk theo plan nếu còn quyền giao dịch.', score: 4 },
      { key: 'C', text: 'Quay về Risk Plan; tuyệt đối không để nhu cầu phục hồi quyết định mức risk.', score: 5 },
      { key: 'D', text: 'Giữ cảm giác nhưng giảm một chút.', score: 3 },
      { key: 'E', text: 'Tăng để lấy lại nhanh.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 74,
    day: 3,
    competency: 'Giảm risk cảm tính',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Sau hai lệnh thua đúng quy trình, Setup tiếp theo đạt chuẩn nhưng plan vẫn cho phép risk bình thường. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Giữ đúng risk nếu plan yêu cầu.', score: 4 },
      { key: 'B', text: 'Không vào vì sợ thua tiếp.', score: 1 },
      { key: 'C', text: 'Giảm một chút để an tâm.', score: 3 },
      { key: 'D', text: 'Mức risk chỉ đổi khi Risk Plan quy định; không để nỗi sợ sau thua tự sửa kế hoạch.', score: 5 },
      { key: 'E', text: 'Giảm rất mạnh theo cảm giác.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 75,
    day: 3,
    competency: 'Vùng Xanh',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Bạn đang ở vùng Xanh. Điều đó có nghĩa gì?',
    options: [
      { key: 'A', text: 'Có thể tăng risk.', score: 1 },
      { key: 'B', text: 'Có thể linh hoạt tiêu chuẩn.', score: 3 },
      { key: 'C', text: 'Có thể giao dịch mọi cơ hội.', score: 2 },
      { key: 'D', text: 'Được giao dịch đúng hệ thống và risk plan, không phải được phép nới kỷ luật.', score: 5 },
      { key: 'E', text: 'Được thực thi theo kế hoạch.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 76,
    day: 3,
    competency: 'Vùng Vàng',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Bạn chuyển sang vùng Vàng. Hành động phù hợp nhất?',
    options: [
      { key: 'A', text: 'Giảm tốc và giảm rủi ro theo quy định.', score: 4 },
      { key: 'B', text: 'Giao dịch như bình thường.', score: 2 },
      { key: 'C', text: 'Tăng tốc để quay về Xanh.', score: 1 },
      { key: 'D', text: 'Chỉ tập trung cơ hội đẹp.', score: 3 },
      { key: 'E', text: 'Kích hoạt chế độ bảo vệ: giảm risk/tần suất, tăng review và chỉ thực thi cơ hội ưu tiên.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 77,
    day: 3,
    competency: 'Vùng Đỏ',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Bạn ở vùng Đỏ. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Chỉ trade nhỏ.', score: 2 },
      { key: 'B', text: 'Dừng bắt buộc, không thương lượng; review và chỉ quay lại khi đủ điều kiện tái kích hoạt.', score: 5 },
      { key: 'C', text: 'Trade nếu Mentor đồng ý.', score: 3 },
      { key: 'D', text: 'Vào một lệnh tốt để phục hồi.', score: 1 },
      { key: 'E', text: 'Dừng.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 78,
    day: 3,
    competency: 'Chuỗi thua',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Ba lệnh thua liên tiếp nhưng đều đúng Setup. Bạn đánh giá gì trước?',
    options: [
      { key: 'A', text: 'Xem chuỗi thua còn nằm trong xác suất, risk budget và điều kiện dừng đã định hay không.', score: 5 },
      { key: 'B', text: 'Cần gỡ lại một phần.', score: 3 },
      { key: 'C', text: 'Hệ thống chắc chắn hỏng.', score: 1 },
      { key: 'D', text: 'Phải đổi chiến lược.', score: 2 },
      { key: 'E', text: 'Risk Plan và chất lượng thực thi.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 79,
    day: 3,
    competency: 'Risk budget',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Risk Budget trong ngày dùng để làm gì?',
    options: [
      { key: 'A', text: 'Ước lượng mức chịu đựng.', score: 3 },
      { key: 'B', text: 'Xác định mục tiêu lời.', score: 1 },
      { key: 'C', text: 'Kiểm soát tổng mức vốn có thể mất trong ngày và ngăn cộng dồn rủi ro ngoài kế hoạch.', score: 5 },
      { key: 'D', text: 'Cho phép số lệnh tối đa bất kể chất lượng.', score: 2 },
      { key: 'E', text: 'Giới hạn tổng rủi ro triển khai.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 80,
    day: 3,
    competency: 'Tổng rủi ro',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Ba lệnh cùng lúc mỗi lệnh 0,5% risk. Bạn nên nhìn gì?',
    options: [
      { key: 'A', text: 'Chỉ từng lệnh riêng.', score: 1 },
      { key: 'B', text: 'Tổng risk đang mở.', score: 4 },
      { key: 'C', text: 'Chỉ lệnh đẹp nhất.', score: 2 },
      { key: 'D', text: 'Tổng 1,5% nhưng không cần xét thêm.', score: 3 },
      { key: 'E', text: 'Tổng risk cộng dồn và tương quan giữa các vị thế so với budget/mandate.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 81,
    day: 3,
    competency: 'Kích thước vị thế',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Position size nên được quyết định bởi gì?',
    options: [
      { key: 'A', text: 'Cảm giác cơ hội đẹp.', score: 3 },
      { key: 'B', text: 'Risk Plan, khoảng SL hợp lý, giá trị mỗi điểm và giới hạn danh mục.', score: 5 },
      { key: 'C', text: 'Mức tự tin.', score: 1 },
      { key: 'D', text: 'Risk cố định và khoảng SL.', score: 4 },
      { key: 'E', text: 'Mục tiêu lợi nhuận.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 82,
    day: 3,
    competency: 'RR và risk',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'RR rất đẹp có cho phép tăng risk không?',
    options: [
      { key: 'A', text: 'RR không tự động tạo quyền tăng risk; risk chỉ thay đổi theo quy tắc đã định.', score: 5 },
      { key: 'B', text: 'Có thể tăng một chút.', score: 2 },
      { key: 'C', text: 'Không, trừ khi Risk Plan cho phép.', score: 4 },
      { key: 'D', text: 'Có, vì lời tiềm năng lớn.', score: 1 },
      { key: 'E', text: 'Tùy cảm giác.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 83,
    day: 3,
    competency: 'Setup chất lượng cao',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Setup A+ có cho phép bỏ qua giới hạn ngày không?',
    options: [
      { key: 'A', text: 'Có nếu chỉ vượt nhẹ.', score: 2 },
      { key: 'B', text: 'Không.', score: 4 },
      { key: 'C', text: 'Không bao giờ; chất lượng Setup và giới hạn risk là hai lớp độc lập.', score: 5 },
      { key: 'D', text: 'Có nếu đang cần mục tiêu.', score: 3 },
      { key: 'E', text: 'Có.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 84,
    day: 3,
    competency: 'Mất quyền giao dịch',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi nào bạn xem mình đã mất quyền giao dịch trong ngày?',
    options: [
      { key: 'A', text: 'Khi chạm điều kiện dừng.', score: 4 },
      { key: 'B', text: 'Khi bị lỗ.', score: 1 },
      { key: 'C', text: 'Khi thua vài lệnh.', score: 3 },
      { key: 'D', text: 'Khi bất kỳ kill-switch nào của Risk Plan bị kích hoạt: loss limit, trạng thái Đỏ, vi phạm nghiêm trọng hoặc điều kiện dừng khác.', score: 5 },
      { key: 'E', text: 'Khi cảm thấy xui.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 85,
    day: 3,
    competency: 'Khôi phục',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Sau khi bị dừng vì vi phạm risk, điều kiện quay lại nên là gì?',
    options: [
      { key: 'A', text: 'Khi thấy cơ hội đẹp.', score: 1 },
      { key: 'B', text: 'Sau 30 phút.', score: 3 },
      { key: 'C', text: 'Khi hết tức.', score: 2 },
      { key: 'D', text: 'Chỉ khi hoàn tất quy trình phục hồi, xác định nguyên nhân, trạng thái ổn định và điều kiện tái kích hoạt được đáp ứng.', score: 5 },
      { key: 'E', text: 'Sau review ngắn.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 86,
    day: 3,
    competency: 'Revenge',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Dấu hiệu sớm của giao dịch trả thù là gì?',
    options: [
      { key: 'A', text: 'Muốn lấy lại số vừa mất.', score: 4 },
      { key: 'B', text: 'Muốn tìm setup mới.', score: 2 },
      { key: 'C', text: 'Muốn xem lại chart.', score: 1 },
      { key: 'D', text: 'Muốn vào nhanh hơn bình thường.', score: 3 },
      { key: 'E', text: 'Mức độ cấp bách tăng, risk/tiêu chuẩn bắt đầu thay đổi và lệnh sau bị chi phối bởi lệnh trước.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 87,
    day: 3,
    competency: 'Loss limit',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Mức lỗ tối đa nên được thiết lập dựa trên gì?',
    options: [
      { key: 'A', text: 'Số tiền tôi thấy chấp nhận được lúc đó.', score: 2 },
      { key: 'B', text: 'Mandate, drawdown cho phép, chiến lược, biến động và khả năng chịu chuỗi thua của hệ thống.', score: 5 },
      { key: 'C', text: 'Cảm giác chịu đựng.', score: 3 },
      { key: 'D', text: 'Mức lợi nhuận muốn đạt.', score: 1 },
      { key: 'E', text: 'Quy mô tài khoản và risk plan.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 88,
    day: 3,
    competency: 'Bảo toàn vốn',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Tại sao bảo toàn vốn quan trọng hơn một cơ hội?',
    options: [
      { key: 'A', text: 'Vì vốn là quyền tham gia tương lai; một cơ hội không thể quan trọng hơn khả năng tiếp tục vận hành.', score: 5 },
      { key: 'B', text: 'Vì cơ hội còn nhiều.', score: 3 },
      { key: 'C', text: 'Vì thua khiến tâm lý xấu.', score: 1 },
      { key: 'D', text: 'Vì cần giữ tài khoản đẹp.', score: 2 },
      { key: 'E', text: 'Vì mất vốn làm giảm khả năng tiếp tục.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 89,
    day: 3,
    competency: 'Rủi ro trước lợi nhuận',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Trước khi hỏi ‘có thể lời bao nhiêu’, bạn nên biết gì?',
    options: [
      { key: 'A', text: 'Mentor nghĩ gì.', score: 3 },
      { key: 'B', text: 'Giá có chạy không.', score: 1 },
      { key: 'C', text: 'Mức mất tối đa, điểm vô hiệu, position size và ảnh hưởng lên risk budget tổng.', score: 5 },
      { key: 'D', text: 'Tin tức nào sắp ra.', score: 2 },
      { key: 'E', text: 'Có thể mất bao nhiêu.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 90,
    day: 3,
    competency: 'Không thương lượng',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi đã cam kết 0,5% risk/lệnh, cơ hội cực đẹp xuất hiện. Bạn làm gì?',
    options: [
      { key: 'A', text: 'Nâng lên 1%.', score: 1 },
      { key: 'B', text: 'Giữ đúng 0,5%.', score: 4 },
      { key: 'C', text: 'Nâng lên 0,75%.', score: 2 },
      { key: 'D', text: 'Giữ 0,5% nhưng thêm lệnh phụ.', score: 3 },
      { key: 'E', text: 'Giữ đúng mức đã cam kết; chỉ thay đổi nếu Risk Plan có quy tắc phân tầng được xác lập từ trước.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 91,
    day: 3,
    competency: 'Vi phạm SL',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Nếu bạn di chuyển SL để tránh thua và cuối cùng lệnh quay lại thắng, bạn ghi nhận thế nào?',
    options: [
      { key: 'A', text: 'Có lỗi nhỏ.', score: 3 },
      { key: 'B', text: 'Vi phạm nghiêm trọng; kết quả thắng không xóa việc phá giới hạn tổn thất đã cam kết.', score: 5 },
      { key: 'C', text: 'Quyết định đúng vì có lời.', score: 1 },
      { key: 'D', text: 'Vi phạm risk dù kết quả tốt.', score: 4 },
      { key: 'E', text: 'May mắn nhưng chấp nhận được.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 92,
    day: 3,
    competency: 'Review sau lỗ',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Sau một lệnh thua đúng quy trình, review nên tập trung vào gì?',
    options: [
      { key: 'A', text: 'Setup, entry, risk, quản lý vị thế, trạng thái và việc lỗ có nằm trong xác suất bình thường hay không.', score: 5 },
      { key: 'B', text: 'Cách gỡ lại.', score: 2 },
      { key: 'C', text: 'Chất lượng quyết định và tuân thủ.', score: 4 },
      { key: 'D', text: 'Tại sao thị trường không đi đúng.', score: 1 },
      { key: 'E', text: 'Setup tiếp theo ở đâu.', score: 3 }
    ],
    maxScore: 5
  },
  {
    id: 93,
    day: 3,
    competency: 'Tần suất',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Nếu đã đạt giới hạn số quyết định trong ngày nhưng xuất hiện thêm cơ hội, bạn làm gì?',
    options: [
      { key: 'A', text: 'Vào nhỏ hơn.', score: 2 },
      { key: 'B', text: 'Dừng theo giới hạn.', score: 4 },
      { key: 'C', text: 'Không mở thêm lệnh nếu giới hạn là một phần Risk Plan; cơ hội không tạo quyền phá giới hạn.', score: 5 },
      { key: 'D', text: 'Hỏi Mentor cho ngoại lệ.', score: 3 },
      { key: 'E', text: 'Vào vì cơ hội đẹp.', score: 1 }
    ],
    maxScore: 5
  },
  {
    id: 94,
    day: 3,
    competency: 'Rủi ro danh mục',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Hai tài sản có tương quan cao cùng cho tín hiệu. Bạn xử lý thế nào?',
    options: [
      { key: 'A', text: 'Xem xét tổng exposure.', score: 4 },
      { key: 'B', text: 'Xem là hai cơ hội độc lập.', score: 1 },
      { key: 'C', text: 'Chia đôi risk theo cảm giác.', score: 3 },
      { key: 'D', text: 'Đánh giá chúng như rủi ro liên quan và phân bổ sao cho tổng exposure vẫn nằm trong budget.', score: 5 },
      { key: 'E', text: 'Vào đủ risk cả hai.', score: 2 }
    ],
    maxScore: 5
  },
  {
    id: 95,
    day: 3,
    competency: 'Drawdown',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi tài khoản bước vào drawdown, điều gì nên thay đổi trước?',
    options: [
      { key: 'A', text: 'Mục tiêu lợi nhuận tăng.', score: 1 },
      { key: 'B', text: 'Hệ thống đổi.', score: 3 },
      { key: 'C', text: 'Số lệnh tăng.', score: 2 },
      { key: 'D', text: 'Kích hoạt quy tắc bảo vệ vốn đã định: risk/tần suất/giới hạn và review, không thay đổi tùy cảm xúc.', score: 5 },
      { key: 'E', text: 'Chế độ quản trị rủi ro theo plan.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 96,
    day: 3,
    competency: 'Rủi ro và cảm xúc',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi bạn rất tự tin, mức risk nên thế nào?',
    options: [
      { key: 'A', text: 'Không đổi nếu plan không đổi.', score: 4 },
      { key: 'B', text: 'Tăng nhẹ.', score: 2 },
      { key: 'C', text: 'Tăng đáng kể.', score: 1 },
      { key: 'D', text: 'Tùy cảm giác.', score: 3 },
      { key: 'E', text: 'Không để cảm xúc tự tin/hưng phấn quyết định risk; chỉ Risk Plan mới được quyền thay đổi.', score: 5 }
    ],
    maxScore: 5
  },
  {
    id: 97,
    day: 3,
    competency: 'Rủi ro và sợ hãi',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Khi bạn rất sợ sau chuỗi thua, mức risk nên thế nào?',
    options: [
      { key: 'A', text: 'Giảm mạnh theo cảm giác.', score: 2 },
      { key: 'B', text: 'Chỉ giảm/dừng theo quy tắc bảo vệ; không để sợ hãi tự ý sửa risk.', score: 5 },
      { key: 'C', text: 'Vào cực nhỏ để lấy lại tự tin.', score: 3 },
      { key: 'D', text: 'Dừng vô thời hạn.', score: 1 },
      { key: 'E', text: 'Theo plan hiện hành.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 98,
    day: 3,
    competency: 'Kill switch',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Một ‘kill switch’ tốt cần có đặc điểm gì?',
    options: [
      { key: 'A', text: 'Có điều kiện định lượng/định tính rõ, kích hoạt tự động và không được thương lượng trong lúc cảm xúc cao.', score: 5 },
      { key: 'B', text: 'Thay đổi theo thị trường.', score: 3 },
      { key: 'C', text: 'Dựa vào linh cảm.', score: 1 },
      { key: 'D', text: 'Mentor quyết định từng lúc.', score: 2 },
      { key: 'E', text: 'Có ngưỡng cụ thể.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 99,
    day: 3,
    competency: 'Tính nhất quán risk',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Mức risk của bạn giữa ngày thắng và ngày thua nên thế nào?',
    options: [
      { key: 'A', text: 'Linh hoạt theo cảm giác.', score: 3 },
      { key: 'B', text: 'Ngày thắng tăng, ngày thua gỡ.', score: 1 },
      { key: 'C', text: 'Nhất quán theo quy tắc; mọi điều chỉnh phải do trạng thái/risk zone/mandate chứ không do P&L gần nhất.', score: 5 },
      { key: 'D', text: 'Ngày thắng tăng nhẹ, ngày thua giảm mạnh.', score: 2 },
      { key: 'E', text: 'Ổn định theo Risk Plan.', score: 4 }
    ],
    maxScore: 5
  },
  {
    id: 100,
    day: 3,
    competency: 'Tổng hợp',
    group: 'Ngày 3 — Quản trị rủi ro',
    text: 'Dấu hiệu mạnh nhất cho thấy bạn đã có ‘Hiến pháp quản trị rủi ro’ là gì?',
    options: [
      { key: 'A', text: 'Tôi nhớ mình không nên mạo hiểm.', score: 1 },
      { key: 'B', text: 'Tôi có giới hạn lệnh/ngày/tuần và điều kiện dừng.', score: 4 },
      { key: 'C', text: 'Tôi biết vài mức SL.', score: 2 },
      { key: 'D', text: 'Tôi có con số risk tham khảo.', score: 3 },
      { key: 'E', text: 'Tôi có bộ quy tắc rõ về risk/lệnh, ngày, tuần, vùng Xanh-Vàng-Đỏ, stop, kill-switch và điều kiện quay lại.', score: 5 }
    ],
    maxScore: 5
  }
];

export function getQuestionsForDay(day: number): Question[] {
  return ALL_QUESTIONS.filter((q) => q.day === day);
}

export function getDayMeta(day: number): DayMeta | undefined {
  const found = DAYS_META.find((d) => d.day === day);
  if (found) return found;
  return {
    day,
    title: `Ngày ${day}`,
    group: `Ngày ${day}`,
    totalQuestions: 34,
    count: 34,
  };
}
